import cookies from "../../cookies"
import { toast } from 'react-toastify';
export const REDUCER_USER = "USER"

const user = (state = [], action) => {
    switch (action.type) {
    case REDUCER_USER+"_ADD": {
        cookies.set("auth", action.newData.token, {maxAge: 86400})
        state = {...state, ...action.newData, isLoading: false, authSuccess: true, message: undefined}
        return state
    }
    case REDUCER_USER+'_LOADING' : {
        state = {...state, isLoading: action.isLoading}
        return state
    }
    case REDUCER_USER+'_ERROR' : {
        state = {...state, isLoading: false, message: action.message}
        toast.error(action.message, {})
        return state
    }
    default:
        return state
    }
}
 
export default user



// WEBPACK FOOTER //
// ./src/Redux/Reducers/user.jsx